import { throwError } from 'rxjs';

export class ResponseHandler {
  constructor() {}
  static processResponse(response: any, method: any): boolean {
    if (response != '') {
      if (response && response.Status && response.Status === AjaxStatus.SUCCESS) {
        return true;
      } else {
        let dataStr = '';
        try {
          dataStr = typeof response === 'object' ? JSON.stringify(response) : response.toString();
        } catch (e: any) {
          dataStr = 'Unparseable data format, error was "' + e.message + '".';
        }
        throwError(
          () =>
            new Error(
              'Ajax error: Invalid response to call on method "' +
                method.getName() +
                '" of class "' +
                method.getClass().className() +
                '", data returned was ' +
                dataStr
            )
        );

        return false;
      }
    } else {
      return false;
    }
  }
}
enum AjaxStatus {
  SUCCESS = 1,
  PERMISSIONS_ERROR,
  APPLICATION_ERROR,
  RESPONSE_ERROR,
}
